/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';
import {CurrencyValueModel} from "./currency-value.model";

export class MasterRoutingSolutionSegmentWithSelectedRS extends JSONable {

  uuid: string | undefined = undefined;
  masterRoutingSolutionUuid: string | undefined = undefined;
  segmentUuid: string | undefined = undefined;
  previousSegmentUuid: string | undefined = undefined;
  cost: CurrencyValueModel | undefined = undefined;
  vehicleType: string | undefined = undefined;
  driverName: string | undefined = undefined;
  licensePlate: string | undefined = undefined;
  paymentTimeLimit: string | undefined = undefined;
  serviceProviderName: string | undefined = undefined;
  pickupCity: string | undefined = undefined;
  pickupCountry: string | undefined = undefined;
  deliveryCity: string | undefined = undefined;
  deliveryCountry: string | undefined = undefined;
  routeUuid: string | undefined = undefined;
  routeTemplateUuid: string | undefined = undefined;
}
